import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            position: 'fixed',
            zIndex: 9999,
            margin: 0,
            padding: 0,
            borderRadius: '4px',
        },
        header: {
            transition: theme.transitions.create(['background'], {
                duration: 300
            })
        },
        headerText: {
            color: theme.palette.text.primary
        },
        advancedButton: {
            fontSize: '13px'
        },
        advancedActive: {
            transform: 'rotateZ(180deg)'
        },
        slTargetLabel: {
            fontSize: '12px'
        },
        disabledInputClickBackdrop: {
            position: "absolute",
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
            cursor: 'pointer'
        }
    }
})